import { render } from "./ValueProps.vue?vue&type=template&id=66da9347&scoped=true&ts=true"
import script from "./ValueProps.vue?vue&type=script&lang=ts"
export * from "./ValueProps.vue?vue&type=script&lang=ts"

import "./ValueProps.vue?vue&type=style&index=0&id=66da9347&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66da9347"]])

export default __exports__